import Cookies from "js-cookie";
import { clone, isEqual } from "lodash";
import { receiveServerErrors } from "../../Shared/Errors/errorActions";

const RECEIVE_CHANNELS = "RECEIVE_CHANNELS";
const RECEIVE_MESSAGES = "RECEIVE_MESSAGES";
const RESET_MESSAGES = "RESET_MESSAGES";
const RECEIVE_MESSAGE = "RECEIVE_MESSAGE";
const RECEIVE_RECIPIENTS = "RECEIVE_RECIPIENTS";
const REQUEST_RECIPIENT = "REQUEST_RECIPIENT";
const RECEIVE_RECIPIENT = "RECEIVE_RECIPIENT";
const RESET_RECIPIENT = "RESET_RECIPIENT";
const RECEIVE_UNREAD_MESSAGE_COUNT = "RECEIVE_UNREAD_MESSAGE_COUNT";
const RECEIVE_UNREAD_MESSAGE = "RECEIVE_UNREAD_MESSAGE";
const RECEIVE_LAST_MESSAGES = "RECEIVE_LAST_MESSAGES";
const RESET_UNREAD_MESSAGE_COUNT = "RESET_UNREAD_MESSAGE_COUNT";

const receiveRecipients = (xhr, user_id) => ({
  type: RECEIVE_RECIPIENTS,
  xhr,
  user_id,
});

const receiveRecipient = (xhr) => ({ type: RECEIVE_RECIPIENT, xhr });

export const resetRecipient = () => ({ type: RESET_RECIPIENT });

export const receiveChannels = (channels) => ({
  type: RECEIVE_CHANNELS,
  channels,
});

export const resetMessages = () => ({ type: RESET_MESSAGES });

export const receiveMessages = (messages, channel) => ({
  type: RECEIVE_MESSAGES,
  messages,
  channel,
});

export const receiveMessage = (message) => ({ type: RECEIVE_MESSAGE, message });

export const receiveUnreadMessage = (channel) => ({
  type: RECEIVE_UNREAD_MESSAGE,
  channel,
});

export const receiveUnreadMessageCounts = (channelCounts) => ({
  type: RECEIVE_UNREAD_MESSAGE_COUNT,
  channelCounts,
});

export const receiveLastMessages = (channel, lastMessage) => ({
  type: RECEIVE_LAST_MESSAGES,
  channel,
  lastMessage,
});

export const resetUnreadMessageCount = (channel) => ({
  type: RESET_UNREAD_MESSAGE_COUNT,
  channel,
});

export const fetchRecipients = (user_ids, user_id) => (dispatch) =>
  $.ajax({
    method: "get",
    url: `${process.env.REACT_APP_BASE_URL}/jwt_api/chats/`,
    data: { user_ids, user_id: Cookies.get("uId") },
    success(xhr) {
      dispatch(receiveRecipients(xhr, user_id));
    },
    error(xhr) {
      dispatch(receiveServerErrors(xhr));
    },
  });

export const fetchRecipient = (id, isVideoAuthorId) => (dispatch) => {
  dispatch({ type: REQUEST_RECIPIENT });
  $.ajax({
    method: "get",
    url: `${process.env.REACT_APP_BASE_URL}/jwt_api/chats/${id}`,
    data: { is_video_author_id: isVideoAuthorId, user_id: Cookies.get("uId") },
    success(xhr) {
      dispatch(receiveRecipient(xhr));
    },
    error(xhr) {
      dispatch(receiveServerErrors(xhr));
      dispatch(
        receiveRecipient({
          user: { first_name: "Not", last_name: "Found", _id: id },
          influencer: {},
        })
      );
    },
  });
};

export const sendMessage = (recipient_id) => (dispatch) => {
  $.ajax({
    method: "post",
    url: `${process.env.REACT_APP_BASE_URL}/jwt_api/chats`,
    data: { recipient_id, user_id: Cookies.get("uId") },
    success() {},
    error(xhr) {
      dispatch(receiveServerErrors(xhr));
    },
  });
};

export const channels = (state = [], payload = {}) => {
  const { type, channels } = payload;
  return type === RECEIVE_CHANNELS ? channels : state;
};

const _nullRecipients = {
  users: [],
  influencers: [],
};

export const recipients = (state = _nullRecipients, payload = {}) => {
  const { type, xhr } = payload;
  return type === RECEIVE_RECIPIENTS ? xhr : state;
};

export const messages = (state = [], payload = {}) => {
  const { type, messages, message } = payload;
  const newState = clone(state);
  switch (type) {
    case RECEIVE_MESSAGES:
      return messages.reverse();
    case RECEIVE_MESSAGE:
      const i = newState.findIndex((prevMessage) =>
        isEqual(prevMessage, message)
      );
      if (i === -1) {
        newState.unshift(message);
      }
      return newState;
    case RESET_MESSAGES:
      return [];
    default:
      return state;
  }
};

export const recipientsFetchedForUser = (state = "", payload = {}) => {
  const { type, user_id } = payload;
  return type === RECEIVE_RECIPIENTS ? user_id : state;
};

export const messagesFetchedForChannel = (state = "", payload = {}) => {
  const { type, channel } = payload;
  return type === RECEIVE_MESSAGES ? channel : state;
};

const _nullRecipeint = {
  user: {},
  influencer: {},
  status: "idle",
};

export const newChatRecipient = (state = _nullRecipeint, payload = {}) => {
  const { type, xhr } = payload;
  // console.log('chat_redux.js:152 ~ newChatRecipient ~ xhr', xhr);
  switch (type) {
    case REQUEST_RECIPIENT:
      return { ...state, status: "loading" };
    case RECEIVE_RECIPIENT:
      return { user: xhr.user, influencer: xhr.influencer, status: "success" };
    case RESET_RECIPIENT:
      return _nullRecipeint;
    default:
      return state;
  }
};

export const unreadMessageCounts = (state = {}, payload = {}) => {
  const { type, channelCounts, channel } = payload;
  // console.log('chat_redux.js:163 ~ unreadMessageCounts ~ channelCounts', channelCounts);
  switch (type) {
    case RECEIVE_UNREAD_MESSAGE_COUNT:
      return channelCounts;
    case RECEIVE_UNREAD_MESSAGE:
      return { ...state, [channel]: state[channel] ? state[channel] + 1 : 1 };
    case RESET_UNREAD_MESSAGE_COUNT:
      return { ...state, [channel]: 0 };
    default:
      return state;
  }
};

export const lastMessages = (state = {}, payload = {}) => {
  const { type, channel, lastMessage } = payload;
  return type === RECEIVE_LAST_MESSAGES
    ? { ...state, ...{ [channel]: lastMessage } }
    : state;
};
